import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, message } from 'antd';
import { CreateOrderForm } from '../components/CreateOrderForm';
import { PageTitle } from '../../components/layouts/page/PageTitle';

import { useOrders as useAdminOrders} from '../../hooks/data/useOrders';

import { Order } from '../../hooks/data/models';

export const OrderCreatePage = () => {
  const navigate = useNavigate();
  const { createOrder, isCreateError } = useAdminOrders();
  const [messageApi, messagesContextHolder] = message.useMessage();

  useEffect(() => {
    if (isCreateError) {
      messageApi.error(isCreateError.message);
    }
  }, [isCreateError, messageApi]);

  const handleSubmit = async (values: any) => {

    if (!values.billingAddress) {
      values.billingAddress = values.shippingAddress;
    }

    const order = values as any as Partial<Order>;

    const newOrder = await createOrder(order);

    if (newOrder)
      navigate(`/orders/detail/${newOrder._id}`);
  };

  return (
    <Layout.Content>
      {messagesContextHolder}
      <PageTitle onBack={() => navigate(-1)} title='Create order' />
      <CreateOrderForm onSubmit={handleSubmit} />
    </Layout.Content>
  );
};

